import { useEffect, useState } from 'react';
import getSPI from '../../../../services/SPI';
const useCurrentUser = () => {
  const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {
    async function fetchCurrentUser() {
      const currentUserResponse = await getSPI().getCurrentUser();
      setCurrentUser(currentUserResponse);
    }
    fetchCurrentUser();
  }, []);
  return currentUser;
};
export { useCurrentUser };